import { RxCaretRight } from "react-icons/rx";
import { Card, CardBody } from "reactstrap";


const ProfileOptionsCard = ({ icon, title, onClick, className }) => {
  return (
    <Card
      onClick={() => onClick({ icon, title })}
      style={{
        borderRadius: "12.55px",
      }}
      className={`${className} cursor-pointer border-none double-shadow f-5 color-primary-blue`}
    >
      <CardBody className="d-flex flex-row  justify-content-between">
        <div className="d-flex align-items-center gap-3">
          <div>{icon}</div>
          <h6 className="m-0 ">{title}</h6>
        </div>
        <RxCaretRight size={35} />
      </CardBody>
    </Card>
  );
};

export default ProfileOptionsCard;
